// eslint-disable-next-line consistent-return
const scrollTo = (function scrollTo(destination, duration = 200, easing = 'linear', callback) {
  const easings = {
    linear(t) {
      return t;
    },
  };

  const start = window.pageYOffset;
  const startTime = 'now' in window.performance ? performance.now() : new Date().getTime();
  const documentHeight = Math.max(
    document.body.scrollHeight,
    document.body.offsetHeight,
    document.documentElement.clientHeight,
    document.documentElement.scrollHeight,
    document.documentElement.offsetHeight,
  );

  const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.getElementsByTagName('body')[0].clientHeight;
  const destOffset = typeof destination === 'number' ? destination : destination.offsetTop;
  const destOffsetToScroll = Math.round(
    documentHeight - destOffset < windowHeight ? documentHeight - windowHeight : destOffset,
  );

  if ('requestAnimationFrame' in window === false) {
    window.scroll(0, destOffsetToScroll);
    if (callback) {
      callback();
    }
  }

  if (window.pageYOffset === destOffsetToScroll) {
    if (callback) {
      callback();
    }
    return;
  }

  function scroll() {
    const now = 'now' in window.performance ? performance.now() : new Date().getTime();
    const time = Math.min(1, ((now - startTime) / duration));
    const timeFunction = easings[easing](time);

    window.scroll(0, Math.ceil((timeFunction * (destOffsetToScroll - start)) + start));

    if (window.pageYOffset === destOffsetToScroll) {
      if (callback) {
        callback();
      }
      return;
    }

    requestAnimationFrame(scroll);
  }

  scroll();
});

const getAnchorHash = (function getAnchorHashIIFE() {
  const anchor = document.getElementsByTagName('a');

  for (let i = 0; i < anchor.length; i += 1) {
    if (anchor[i].hash.substr(1) !== '') {
      anchor[i].addEventListener('click', (event) => {
        scrollTo(
          document.getElementById(event.target.hash.substr(1)),
          300,
          'linear',
        );
      });
    }
  } 
}());

const accordionInit = (function accordionIIFE() {
  const accordionTitle = document.querySelectorAll('.accordion-title');
  accordionTitle.forEach((accordion) => {
    accordion.addEventListener('click', (event) => {
      accordion.classList.toggle('accordion-title-open');
    });
  });
}());


const menuMobileInit = (function menuMobileIIFE() {
  const menuMobileIcon = document.getElementsByClassName("nav-icon-container")[0];

  menuMobileIcon.addEventListener('click', (event) => {
    console.log( event.currentTarget.classList.contains('nav-icon-container-open') );

    if( event.currentTarget.classList.contains('nav-icon-container-open') ) {
      event.currentTarget.setAttribute("class", "nav-icon-container")

    } else {
      event.currentTarget.setAttribute("class", "nav-icon-container nav-icon-container-open")

    }

  });
  
}());

jQuery(window).scroll(function() {

  if (jQuery(this).scrollTop() == 0){  
    jQuery('.header').addClass("header-transparent");
  }
  else{
    jQuery('.header').removeClass("header-transparent");
  }
});

jQuery(document).ready(function(){

  jQuery('.sub-menu-column .nav-menu-link').hover( function(e) {

    const target = jQuery(e.currentTarget).parent();

    const title = target.attr('data-box-title');
    const boxLink = target.attr('data-box-href');
    const boxImage = target.attr('data-box-image');


    jQuery(jQuery(target.parent()).next()).find('h3').html(title);
    jQuery(jQuery(target.parent()).next()).find('a').attr("href", boxLink);
    jQuery(jQuery(target.parent()).next()).find('img').attr("src", boxImage);

  });

  var elementsSubMenuColumn = jQuery('.sub-menu-column .nav-menu-item:first-child .nav-menu-link');
  elementsSubMenuColumn.each(function( index ) {
    jQuery( this ).trigger('mouseenter');
  });

  function isMobile() {
    let check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
  };

  if (!isMobile()) {
    eventClick = "click";

  } else {
    eventClick = "touchend";

  }

  jQuery('.nav-mobile .menu-item-has-children').on( eventClick, function(e) {
    var currentTarget = e.currentTarget;

    jQuery( currentTarget ).find('.sub-menu').toggleClass('sub-menu-active');
    jQuery( currentTarget ).toggleClass('menu-item-has-children-active');

  });

  jQuery('.owl-carousel').owlCarousel({
    autoplay:true,
    autoplayTimeout:6000,
    nav:true,
    loop:true,
    dots: true,
    margin:0,
    items:1,
    navText: [
      '<svg id="Group_5" data-name="Group 5" xmlns="http://www.w3.org/2000/svg" width="32" height="21.333" viewBox="0 0 32 21.333"><path id="Path_5" data-name="Path 5" d="M13.333,22.667,0,13.216,13.333,4V8.056S28.824,11.5,32,25.333c-6.763-7.241-18.667-6.957-18.667-6.957Z" transform="translate(0 -4)"/></svg><span aria-label="' + 'Previous' + '">poprzednia opinia</span>',
      '<span aria-label="' + 'Next' + '">następna opinia</span><svg xmlns="http://www.w3.org/2000/svg" width="32" height="21.333" viewBox="0 0 32 21.333"><g id="Group_5" data-name="Group 5" transform="translate(0 -4)"><path id="Path_5" data-name="Path 5" d="M18.667,22.667,32,13.216,18.667,4V8.056S3.176,11.5,0,25.333c6.763-7.241,18.667-6.957,18.667-6.957Z"/></g></svg>'
    ]
  });

});